const initialState = {
  parentMenuData: [],
  getMenusLoading: false,
  menuCategories: [],
  offers: [],
  menuItems: [],
  menuLoading: false,
  offerLoading: false,
  categoriesLoading: false,
  recommendedData: {},
};

export default function MenuReducers(state = initialState, { type, payload }) {
  switch (type) {
    case "PARENT_MENUS":
      return {
        ...state,
        parentMenuData: payload,
      };
    case "GET_RECOMMENDED_DATA":
      return {
        ...state,
        recommendedData: payload,
      };
    case "FETCH_OFFERS":
      return {
        ...state,
        offers: payload,
      };
    case "MENU_CATEGORIES":
      return {
        ...state,
        menuCategories: payload,
      };
    case "CATEGORIES_LOADER":
      return {
        ...state,
        categoriesLoading: payload,
      };
    case "MENU_ITEMS":
      return {
        ...state,
        menuItems: payload,
      };
    case "MENU_LOADER":
      return {
        ...state,
        menuLoading: payload,
      };
    case "OFFER_LOADER":
      return {
        ...state,
        offerLoading: payload,
      };
    case "MENU_DETAIL_LOADER":
      return {
        ...state,
        getMenusLoading: payload,
      };

    default:
      return { ...state };
  }
}
